import React, { forwardRef, useImperativeHandle,useState, useEffect, useRef } from 'react';
import { Table, Tbody, Tr, Td, Th, Thead, TableContainer, Box, Text } from '@chakra-ui/react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { BASE_URL } from '../../../Globalapi/Globalapi';

const Print_Pdf =forwardRef( ({ studentData, userId },ref) => {
  const { user_id } = useParams();
  const [examResults, setExamResults] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [categories, setCategories] = useState({});
  const [filteredCategories, setFilteredCategories] = useState([]);
  const [marksData, setMarksData] = useState([]);
  const [examCategories, setExamCategories] = useState([]);
  const printRef = useRef();
  useImperativeHandle(ref, () => ({
    handlePrint
  }));
  useEffect(() => {
    const fetchExamResults = async () => {
      try {
        const [examResponse, categoryResponse] = await Promise.all([
          axios.post(`${BASE_URL}/student/exam_result_graph.php`, { pass: user_id }),
          axios.get(`${BASE_URL}/admin/exam/exam_category.php`),
        ]);

        if (examResponse.data.success && categoryResponse.data.success) {
          const results = examResponse.data.data || [];
          const filteredExamResults = results.filter((result) => result.is_class_test === "1");
          setExamResults(filteredExamResults);

          const categoryMap = categoryResponse.data.data.reduce((acc, item) => {
            acc[item.id] = item.category;
            return acc;
          }, {});
          setCategories(categoryMap);

          const uniqueSubjects = Array.from(new Set(filteredExamResults.map((result) => result.subject)));
          setSubjects(uniqueSubjects);

          const categoriesWithData = Object.keys(categoryMap).filter(
            (categoryId) => filteredExamResults.some((result) => result.exam_category_id === categoryId)
          );
          setFilteredCategories(categoriesWithData);
        }
      } catch (error) {
        console.error("Error fetching data: ", error);
      }
    };

    const fetchMarks = () => {
      fetch(`${BASE_URL}/student/exam_result_graph.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ pass: user_id }),
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.success) {
            setMarksData(data.data);
          }
        })
        .catch((error) => {
          console.error("Error fetching marks data:", error);
        });
    };

    const fetchExamCategories = () => {
      fetch(`${BASE_URL}/admin/exam/exam_category.php`)
        .then((response) => response.json())
        .then((data) => {
          if (data.success) {
            setExamCategories(data.data);
          }
        })
        .catch((error) => {
          console.error("Error fetching exam categories:", error);
        });
    };

    fetchExamResults();
    fetchMarks();
    fetchExamCategories();
  }, [user_id]);

  const filteredExamCategories = examCategories.filter((category) =>
    marksData.some((exam) => exam.exam_category_id === category.id)
  );

  const subjectsForMarks = Array.from(new Set(marksData.map((exam) => exam.subject)));

  const marksBySubject = subjectsForMarks.map((subject) => {
    const subjectData = {};
    filteredExamCategories.forEach((category) => {
      const exam = marksData.find(
        (mark) => mark.exam_category_id === category.id && mark.subject === subject
      );
      subjectData[category.category] = exam || { written_mark: "-", internal_mark: "-", student_scored_marks: "-" };
    });
    return { subject, data: subjectData };
  });

  const handlePrint = () => {
    const content = printRef.current.innerHTML;
    const iframe = document.createElement("iframe");
    iframe.style.position = "absolute";
    iframe.style.width = "0";
    iframe.style.height = "0";
    iframe.style.border = "none";
    document.body.appendChild(iframe);
  
    const iframeDoc = iframe.contentWindow.document;
    iframeDoc.open();
    iframeDoc.write(`<div>${content}</div>`);
    iframeDoc.close();
  
    // Wait for the image to load before printing
    const images = iframeDoc.getElementsByTagName("img");
    const loadPromises = Array.from(images).map(
      (img) =>
        new Promise((resolve) => {
          img.onload = resolve;
          img.onerror = resolve; // Resolve on error to prevent blocking
        })
    );
  
    Promise.all(loadPromises).then(() => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
      document.body.removeChild(iframe);
    });
  };

  const basicInfo = [
    { label: "Name", value: studentData.name },
    { label: "Email ID", value: studentData.email },
    { label: "Gender", value: studentData.gender },
    { label: "Medium", value: studentData.caption },
    { label: "Date of Birth", value: studentData.date_of_birth },
    { label: "Blood Group", value: studentData.group },
    { label: "Aadhar Number", value: studentData.aadhar_no },
  ];

  const homeAddress = [
    { label: "Address", value: studentData.address },
    { label: "Mobile No", value: studentData.father_number },
  ];

  const parentDetails = [
    { label: "Guardian's Name", value: studentData.guardian_name },
    { label: "Father's Name", value: studentData.father_name },
    { label: "Mother's Name", value: studentData.mother_name },
    { label: "Mother's Number", value: studentData.mother_number },
    { label: "Father's Number", value: studentData.father_number },
  ];


  return (
    <div>
      <div ref={printRef} style={{ padding: '20px', fontFamily: 'Arial, sans-serif', lineHeight: '1.5' }}>
        
        {/* Header with Logo */}
        <div
        style={{
          display: "flex",
          alignItems: "center",
          marginBottom: "40px",
          borderBottom: "2px solid #000",
          paddingBottom: "20px",
          textAlign: "center",
        }}
      >
        <img
          src="https://www.vimalagiriinternational.com/static/media/logo-removebg-preview%20(1).1b7b766c8c63e51dbc52.png"
          alt="Vimalagiri Logo"
          style={{ width: "180px", height: "auto", marginBottom: "10px" }}
          onError={() => console.error("Error loading logo image")}
        />
        <div>
          <h1 style={{ margin: "0", fontSize: "72px", fontWeight: "bold", lineHeight: "0.7", fontFamily: "'Times New Roman', serif" }}>
            Vimalagiri
          </h1>
          <h2 style={{ margin: "0", fontSize: "28px", fontWeight: "bold", marginTop: "10px", fontFamily: "'Times New Roman', serif" }}>
            International School
          </h2>
          <Text style={{ fontSize: "16px", color: "#777", marginTop: "10px" }}>
            Affiliated to CISCE New Delhi Aff.No.KE143
          </Text>
        </div>
      </div>

   {/* Profile Information Sections */}
   <div style={{ marginBottom: '40px' }}>
          <h2>Basic Information</h2>
          <Table  sx={{
                "tbody tr:nth-of-type(even)": { backgroundColor: "#f2f4f8" },
              }} size="sm" border="1px solid #d4c2c2" style={{ borderCollapse: 'collapse', width: '100%' }}>
            <Tbody>
              {basicInfo.map((info) => (
                <Tr key={info.label}>
                  <Td style={{ border: '1px solid #d4c2c2', padding: '8px', fontWeight: 'bold' }}>{info.label}</Td>
                  <Td style={{ border: '1px solid #d4c2c2', padding: '8px' }}>{info.value || "N/A"}</Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </div>

        <div style={{ marginBottom: '40px' }}>
          <h2>Home Address</h2>
          <Table  sx={{
                "tbody tr:nth-of-type(even)": { backgroundColor: "#f2f4f8" },
              }} size="sm" border="1px solid #d4c2c2" style={{ borderCollapse: 'collapse', width: '100%' }}>
            <Tbody>
              {homeAddress.map((info) => (
                <Tr key={info.label}>
                  <Td style={{ border: '1px solid #d4c2c2', padding: '8px', fontWeight: 'bold' }}>{info.label}</Td>
                  <Td style={{ border: '1px solid #d4c2c2', padding: '8px' }}>{info.value || "N/A"}</Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </div>

        <div style={{ marginBottom: '40px' }}>
          <h2>Parent Details</h2>
          <Table  sx={{
                "tbody tr:nth-of-type(even)": { backgroundColor: "#f2f4f8" },
              }} size="sm" border="1px solid #d4c2c2" style={{ borderCollapse: 'collapse', width: '100%' }}>
            <Tbody>
              {parentDetails.map((info) => (
                <Tr key={info.label}>
                  <Td style={{ border: '1px solid #d4c2c2', padding: '8px', fontWeight: 'bold' }}>{info.label}</Td>
                  <Td style={{ border: '1px solid #d4c2c2', padding: '8px' }}>{info.value || "N/A"}</Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </div>

        {/* Page Break */}
        <div className="page-break"></div>

        {/* Second Page: Combined Class Test and Annual Report Tables */}
        <div style={{ marginBottom: '40px', pageBreakBefore: 'always' }}>
          <h2>Class Test Results</h2>
          {examResults.length > 0 ? (
            <TableContainer>
              <Table  sx={{
                "tbody tr:nth-of-type(even)": { backgroundColor: "#f2f4f8" },
              }} size="sm" border="1px solid #d4c2c2" style={{ borderCollapse: 'collapse', width: '100%' }}>
                <Thead>
                  <Tr>
                    <Th style={{ border: '1px solid #d4c2c2', padding: '8px' }}>Subjects</Th>
                    <Th style={{ border: '1px solid #d4c2c2', padding: '8px' }}>Details</Th>
                    {filteredCategories.map((categoryId) => (
                      <Th key={categoryId} colSpan={5} textAlign="center" style={{ border: '1px solid #d4c2c2', padding: '8px' }}>
                        {categories[categoryId]}
                      </Th>
                    ))}
                  </Tr>
                </Thead>
                <Tbody>
                  {subjects.map((subject) => (
                    <React.Fragment key={subject}>
                      <Tr>
                        <Td rowSpan={2} style={{ border: '1px solid #d4c2c2', padding: '8px' }}>{subject}</Td>
                        <Td style={{ border: '1px solid #d4c2c2', padding: '8px' }}>Date</Td>
                        {filteredCategories.flatMap((categoryId) => {
                          const subjectResults = examResults.filter(
                            (result) => result.subject === subject && result.exam_category_id === categoryId
                          );
                          return Array.from({ length: 5 }).map((_, index) => (
                            <Td key={`${categoryId}_date_${index}`} textAlign="center" style={{ border: '1px solid #d4c2c2', padding: '8px' }}>
                              {subjectResults[index]?.date_of_exam || "-"}
                            </Td>
                          ));
                        })}
                      </Tr>
                      <Tr>
                        <Td style={{ border: '1px solid #d4c2c2', padding: '8px' }}>Mark</Td>
                        {filteredCategories.flatMap((categoryId) => {
                          const subjectResults = examResults.filter(
                            (result) => result.subject === subject && result.exam_category_id === categoryId
                          );
                          return Array.from({ length: 5 }).map((_, index) => (
                            <Td key={`${categoryId}_mark_${index}`} textAlign="center" style={{ border: '1px solid #d4c2c2', padding: '8px' }}>
                              {subjectResults[index]?.student_scored_marks || "-"}
                            </Td>
                          ));
                        })}
                      </Tr>
                    </React.Fragment>
                  ))}
                </Tbody>
              </Table>
            </TableContainer>
          ) : (
            <Text>No Data Available</Text>
          )}
        </div>

        {/* Annual Report Table */}
        <div style={{ marginBottom: '40px' }}>
          <h2>Annual Report</h2>
          <TableContainer>
            <Table  sx={{
                "tbody tr:nth-of-type(even)": { backgroundColor: "#f2f4f8" },
              }} size="sm" border="1px solid #d4c2c2" style={{ borderCollapse: 'collapse', width: '100%' }}>
              <Thead>
                <Tr>
                  <Th style={{ border: '1px solid #d4c2c2', padding: '8px' }}>Subjects</Th>
                  {filteredExamCategories.map((category) => (
                    <Th key={category.id} colSpan={3} textAlign="center" style={{ border: '1px solid #d4c2c2', padding: '8px' }}>
                      {category.category}
                    </Th>
                  ))}
                </Tr>
                <Tr>
                  <Th style={{ border: '1px solid #d4c2c2', padding: '8px' }}></Th>
                  {filteredExamCategories.map((category) => (
                    <React.Fragment key={category.id}>
                      <Th style={{ border: '1px solid #d4c2c2', padding: '8px' }}>WE</Th>
                      <Th style={{ border: '1px solid #d4c2c2', padding: '8px' }}>IA</Th>
                      <Th style={{ border: '1px solid #d4c2c2', padding: '8px' }}>Total</Th>
                    </React.Fragment>
                  ))}
                </Tr>
              </Thead>
              <Tbody>
                {marksBySubject.map((item, index) => (
                  <Tr key={index} style={{ backgroundColor: index % 2 === 0 ? '#f9f9f9' : '#ffffff' }}>
                    <Td style={{ border: '1px solid #d4c2c2', padding: '8px' }}>{item.subject}</Td>
                    {filteredExamCategories.map((category) => {
                      const data = item.data[category.category] || {};
                      return (
                        <React.Fragment key={category.id}>
                          <Td style={{ border: '1px solid #d4c2c2', padding: '8px' }}>{data.written_mark || "-"}</Td>
                          <Td style={{ border: '1px solid #d4c2c2', padding: '8px' }}>{data.internal_mark || "-"}</Td>
                          <Td style={{ border: '1px solid #d4c2c2', padding: '8px' }}>{data.student_scored_marks || "-"}</Td>
                        </React.Fragment>
                      );
                    })}
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </TableContainer>
        </div>
      </div>
    </div>
  );
});

export default Print_Pdf;
